import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from "react-js-loader";
import { Pagination } from '../../../../components';
import axiosInstance from '../../../../services/AxiosInstance';

const ConJobsandCandis = () => {

    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        getData();
    }, []);

    const getData = (page = 1) => {
        axiosInstance(`post-jobs/?page=${page}&fields=id,title,payment_status,amount,vacancies,candidates_sent,matchedCandidates,rejected,state,country,category,job_status`, { method: "GET" })
            .then(res => setData(res.data))
            .finally(() => setLoader(false))
    }

    return (
        <>
            <div className="job-bx job-profile">
                <div className="job-bx-title clearfix">
                    <h5 className="font-weight-700 pull-left text-uppercase">Filter Candidates</h5>
                    <Link to={"/all-jobs"} className="site-button right-arrow button-sm float-right">Back</Link>
                </div>
                {
                    loader ?
                        <Loader
                            type="spinner-cub"
                            bgColor={"#2e55fa"}
                            title={"bubble-top"}
                            color={'#FFFFFF'}
                            size={100}
                        />
                        :
                        <table className="table-job-bx cv-manager company-manage-job">
                            <thead>
                                <tr className="text-center">
                                    <th rowSpan={2}>Jobs & Company</th>
                                    <th rowSpan={2}>Vacancies/ Matched</th>
                                    {/* <th rowSpan={2}>Matched</th> */}
                                    <th rowSpan={2}>Job & Payment</th>
                                    {/* <th rowSpan={2}>Payment</th> */}
                                    <th className="p-0" colSpan={2}>
                                        Resumes
                                    </th>
                                    <th rowSpan={2}>Candidates</th>
                                </tr>
                                <tr>
                                    <th className="text-center p-0">Sent</th>
                                    <th className="text-center p-0">Rejected</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data?.results?.length > 0 ? data?.results?.map(res =>
                                        <tr key={res.title}>
                                            <td className="job-name" width="48%" key="canjobfiljobs">
                                                <Link to={"#"}>{res.title.name} - {res?.institution}</Link>
                                                <ul className="job-post-info">
                                                    <li><i className="fa fa-map-marker"></i> {res.state.name}, {res.country.name}</li>
                                                    <li><i className="fa fa-filter"></i>{res.category.map(ct => ct.name).join(', ')}</li>
                                                </ul>
                                            </td>
                                            <td width="8%" key="canjobfilcnt1" className="application text-primary text-center">{res?.vacancies}/{res?.matchedCandidates}</td>
                                            {/* <td width="8%" key="canjobfilcnt2" className="application text-primary text-center">{res?.matchedCandidates}</td> */}
                                            <td width="18%" key="canjobfilcnt2" className="application text-primary text-center">{res?.job_status}/
                                                {res?.payment_status ? `Paid (${res?.country?.symbol} ${res.amount})` : 'Not Paid'}</td>
                                            {/* <td width="14%" key="canjobfilcnt3" className="application text-primary">{res?.payment_status ? `Paid (${res?.country?.symbol} ${res.amount})` : 'Not Paid'}</td> */}
                                            <td width="5%" key="canjobfilcnt4" className="application text-primary">{res?.candidates_sent}</td>
                                            <td width="5%" key="canjobfilcnt5" className="application text-danger">{res?.rejected || '-'}</td>
                                            <td width="10%" key="canjobfilact" className="job-links text-center" style={{ display: "table-cell" }} >
                                                <Link to={`/joc/joc-suggest-candidates/${res.id}/${res.vacancies}`} title='View Matching Candidates'>
                                                    <i className="fa fa-eye"></i>
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                        :
                                        <tr>
                                            <td colSpan={7}>
                                                <div className="alert alert-danger">
                                                    <h5 className="text-center">No Data Found</h5>
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                }

            </div>
            <Pagination data={data} getData={getData} />
        </>
    );
};

export default ConJobsandCandis;